import React from "react";
import { Button } from "@mui/material";
import { cssProperties } from "../../utils/commonCssProperties";

export default function GreenButton({ title, type, handleSubmit,icon ,disabled, flag}) {

    return (
        <Button
            type={type}
            disableElevation
            variant="contained"
            sx={{
                cursor:flag=="true" ? 'default' :"pointer",
                borderRadius: '10px',
                padding: '0px 24px',
                height: '40px',
                backgroundColor: `green`,
                fontSize: '14px',
                fontWeight: '600',
                lineHeight: '15.4px',
                letterSpacing: '0.32px',
                boxShadow: 'none',
                border: '1px solid transparent',
                "&:hover": {
                    backgroundColor: 'green', 
                },
                "&:focus": {
                    backgroundColor: 'green',
                },
                "&.Mui-disabled": {
                    backgroundColor: '#A5D6A7', 
                    color: 'white', 
                    opacity: 0.7, 
                    cursor: flag=="true" ? 'default' :'pointer', 
                }
                
            }}
            onClick={handleSubmit}
            startIcon={icon}
            disabled={disabled}
        >
            {title}
        </Button>
    )
}